import { BrandingResponse } from '../../../types/Branding.types';

export interface TabConfig {
  key: string;
  labelKey: string;
  type: 'chart' | 'table';
  helpKey: string;
  queryKey: string;
  chartType?: 'horizontal' | 'vertical';
  adminOnly?: boolean;
  requiredExtension?: keyof NonNullable<BrandingResponse['extensions']>;
}

export const STATISTICS_TAB_CONFIG: TabConfig[] = [
  {
    key: 'topSearches',
    labelKey: 'statistics.tabs.topSearches',
    type: 'chart',
    helpKey: 'statistics.help.topSearches',
    queryKey: 'topSearches',
    chartType: 'horizontal',
  },
  {
    key: 'noResults',
    labelKey: 'statistics.tabs.noResults',
    type: 'chart',
    helpKey: 'statistics.help.noResults',
    queryKey: 'noResults',
    chartType: 'horizontal',
  },
  {
    key: 'searchFilters',
    labelKey: 'statistics.tabs.searchFilters',
    type: 'chart',
    helpKey: 'statistics.help.searchFilters',
    queryKey: 'searchFilters',
    chartType: 'horizontal',
  },
  {
    key: 'clicks',
    labelKey: 'statistics.tabs.clicks',
    type: 'chart',
    helpKey: 'statistics.help.clicks',
    queryKey: 'clicks',
    chartType: 'horizontal',
  },
  {
    key: 'agreements',
    labelKey: 'statistics.tabs.agreements',
    type: 'chart',
    helpKey: 'statistics.help.agreements',
    queryKey: 'agreements',
    chartType: 'horizontal',
  },
  {
    key: 'journals',
    labelKey: 'statistics.tabs.journals',
    type: 'table',
    helpKey: 'statistics.help.journals',
    queryKey: 'journals',
  },
  {
    key: 'widgetOrigins',
    labelKey: 'statistics.tabs.widgetOrigins',
    type: 'table',
    helpKey: 'statistics.help.widgetOrigins',
    queryKey: 'widgetOrigins',
  },
  {
    key: 'accountActivity',
    labelKey: 'statistics.tabs.accountActivity',
    type: 'chart',
    helpKey: 'statistics.help.accountActivity',
    queryKey: 'accountActivity',
    chartType: 'horizontal',
    adminOnly: true,
  },
  {
    key: 'collections',
    labelKey: 'statistics.tabs.collections',
    type: 'chart',
    helpKey: 'statistics.help.collections',
    queryKey: 'collections',
    chartType: 'horizontal',
    requiredExtension: 'collections',
  },
];
